export default __webpack_public_path__ + "static/media/modifiers.2ebe0a41.png";